import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const AuthContext = createContext({
  token: null,
  setToken: () => {},
  username: '',
  email: '',
  avatar: '',
  setAvatar: () => {},        // <-- Default‐Stub
});

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('JWT'));
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [avatar, setAvatar] = useState('');

  // Lädt Benutzer-Daten (Username, Email, Avatar)
  const fetchUserData = async () => {
    if (!token) return;
    try {
      const response = await axios.post('/get_avatar', {
        headers: {'Access-Control-Allow-Origin': '*',
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
          'Method': 'GET',
      },
      });
      const data = response.data.data;
      setAvatar(data.data || '');
      setUsername(data.user_name || '');
      setEmail(data.email || '');
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  useEffect(() => {
    if (token) {
      localStorage.setItem('JWT', token);
      localStorage.setItem('authenticated', 'true');
      fetchUserData();
    } else {
      localStorage.removeItem('JWT');
      localStorage.removeItem('authenticated');
      setUsername('');
      setEmail('');
      setAvatar('');
    }
  }, [token]);

  return (
    <AuthContext.Provider value={{ token, setToken, username, email, avatar,setAvatar }}>
      {children}
    </AuthContext.Provider>
  );
}
